import { fetchCart, fetchCartUpdate } from "api/interna-api";
import { AnyAction } from "redux";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  APPLY_DSP_CODE,
  APPLY_DSP_CODE_ERROR,
  APPLY_DSP_CODE_SUCCESS,
  CHANGE_STATUS_IS_HAVE_SETUP_SERVICE,
  DECREASE_INCREASE_CART_PRODUCTS,
  FETCH_CART_PRODUCTS,
  fetchCartProductsOnError,
  fetchCartProductsOnSuccess,
  REMOVE_CART_PRODUCTS,
  REMOVE_DSP_CODE,
  REMOVE_DSP_CODE_SUCCESS,
  REMOVE_PROMOTION_CODE,
  REMOVE_PROMOTION_CODE_SUCCESS,
  UPDATE_CART_PRODUCTS,
  USE_PROMOTION_CODE,
  USE_PROMOTION_CODE_ERROR,
  USE_PROMOTION_CODE_SUCCESS
} from "redux/actions/products/cart";

const getCart = () => {
  const LocalCart = window.localStorage.getItem("cart");
  if (LocalCart) {
    const LOCAL_CART = JSON.parse(LocalCart);
    return LOCAL_CART.map((c: any) => {
      return {
        ...c,
        isHaveSetupService: c.isHaveSetupService || 0,
      };
    });
  }
  return [];
};

const saveCartInLocalStorage = (product: any, quantity = 1, sign: string) => {
  let cart = getCart();
  let foundProduct = cart.find(p => p.productId === product.product_id);
  if (foundProduct) {
    if (sign === "+") {
      foundProduct.quantity += quantity;
    } else {
      foundProduct.quantity -= quantity;
    }
  } else {
    cart = [
      ...cart,
      {
        productId: product.product_id,
        quantity: quantity,
        isHaveSetupService: 1,
        useTradeProduct: false,
        tradeProductTemp: false,
        ...(product?.mainCrossSellProductId && { mainCrossSellProductId: product.mainCrossSellProductId }),
      },
    ];
  }
  // TODO: SET CART INCLUDE CASHBACK:
  window.localStorage.setItem("cart", JSON.stringify(cart));
  return cart;
};

const removeProductInLocalStorage = (productId: number) => {
  const cart = getCart();
  const newCart = cart.filter((p) => p.productId !== productId);
  window.localStorage.setItem("cart", JSON.stringify(newCart));
};

const saveIsHaveSetupService = (productId: number) => {
  let cart = getCart();
  // console.log('saveIsHaveSetupService', cart)
  cart = cart.map(p =>
    p.productId === productId
      ? {
        ...p,
        // isHaveSetupService:  Number(!p.isHaveSetupService)
      }
      : p,
  );

  // TODO: SET CART INCLUDE CASHBACK:
  window.localStorage.setItem("cart", JSON.stringify(cart));
  return cart;
};

export const changeStatusOfTradeProduct = async (
  productId: number,
  isStatus: boolean,
) => {
  let cart = getCart();
  cart = cart.map(p =>
    p.productId === productId
      ? {
        ...p,
        useTradeProduct: isStatus,
      }
      : p,
  );

  // TODO: SET CART INCLUDE CASHBACK:
  window.localStorage.setItem("cart", JSON.stringify(cart));
};

export const changeStatusOfTradeProductTemp = async (
  productId: number,
  isStatus: boolean,
) => {
  let cart = getCart();
  cart = cart.map(p =>
    p.productId === productId
      ? {
        ...p,
        tradeProductTemp: isStatus,
      }
      : p,
  );

  // TODO: SET CART INCLUDE CASHBACK:
  window.localStorage.setItem("cart", JSON.stringify(cart));
};

export const resetStatusOfTradeProduct = async (callback?: () => void) => {
  let cart = getCart();
  cart = cart.map((p) => ({
    ...p,
    useTradeProduct: false,
    tradeProductTemp: false
  }));

  // TODO: SET CART INCLUDE CASHBACK:
  window.localStorage.setItem("cart", JSON.stringify(cart));

  if (callback) callback();
};

export const saveRenewalValue = (
  productId: number,
  brandValue: string,
  wattage: string,
  usedTime: string,
  doesItWork: string,
) => {
  const localRenewalValue = window.localStorage.getItem("renewal");
  if (localRenewalValue) {
    const LOCAL_RENEWAL_VALUE = JSON.parse(localRenewalValue);

    window.localStorage.setItem(
      "renewal",
      JSON.stringify([
        ...LOCAL_RENEWAL_VALUE,
        {
          productId,
          brandValue,
          wattage,
          usedTime,
          doesItWork,
        },
      ]),
    );
  } else {
    window.localStorage.setItem(
      "renewal",
      JSON.stringify([
        {
          productId,
          brandValue,
          wattage,
          usedTime,
          doesItWork,
        },
      ]),
    );
  }
};

export const removeRenewalValue = (productId?: number) => {
  const localRenewalValue = window.localStorage.getItem("renewal");
  if (localRenewalValue && localRenewalValue.length > 0) {
    const LOCAL_RENEWAL_VALUE = JSON.parse(localRenewalValue);

    window.localStorage.setItem(
      "renewal",
      JSON.stringify(
        LOCAL_RENEWAL_VALUE.filter(data => data.productId !== productId),
      ),
    );
  }
};

function* decreaseIncreaseCartProductsFlow({
  product,
  sign,
  code,
  dspCode,
  hasBuyMoreGetMore,
  checkAction,
}: AnyAction) {
  try {
    let cart: LocalCartItem[] = saveCartInLocalStorage(product, 1, sign);
    const prevItemId = localStorage.getItem("prevcartitemId");

    if (prevItemId) {
      const prevItem: LocalPrevCartItem = JSON.parse(prevItemId);
      cart = cart.filter(
        item =>
          item.productId !== prevItem.id ||
          (item.productId === prevItem.id && !prevItem.isError),
      );
    }

    const data = yield call(fetchCart, cart, hasBuyMoreGetMore ? code : "", dspCode);

    const resHasBuyMoreGetMore = data?.list?.some((p) => p.buyMoreGetMore && p.buyMoreGetMore.quantity)
    if (!resHasBuyMoreGetMore && hasBuyMoreGetMore) sessionStorage.removeItem("_cabh_");
    yield put(fetchCartProductsOnSuccess(data, !resHasBuyMoreGetMore && hasBuyMoreGetMore ? [] : code, checkAction, dspCode));
  } catch (error) {
    removeProductInLocalStorage(product.product_id);
    yield put(fetchCartProductsOnError(error));
  }
}

function* updateCartFlow({ product, quantity, hasBuyMoreGetMore }: AnyAction) {
  try {
    const codesState = yield select(
      (state: any) => state.products.cart.code,
    );
    let cart = saveCartInLocalStorage(product, quantity, "+");

    const data = yield call(fetchCart, cart, hasBuyMoreGetMore ? codesState : codesState[0] || "", "");

    yield put(fetchCartProductsOnSuccess(data));
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

// PROMOTION CODE:
function* applyPromotionCodeFlow({ code, hasBuyMoreGetMore }: AnyAction) {
  try {
    const dspCodeState = yield select(
      (state: any) => state.products.cart.dspCode,
    );
    let cart = getCart();
    let data = [];
    if (cart.length > 0) {
      data = yield call(fetchCart, cart, hasBuyMoreGetMore ? code : code[0] || "", dspCodeState);
    }
    yield put(
      fetchCartProductsOnSuccess(data, code, USE_PROMOTION_CODE_SUCCESS, dspCodeState),
    );
  } catch (error) {
    yield put(fetchCartProductsOnError(error, USE_PROMOTION_CODE_ERROR));
  }
}

function* removeCartFlow({ code, dspCode, hasBuyMoreGetMore }: AnyAction) {
  try {
    const checkActionState = yield select(
      (state: any) => state.products.cart.checkAction,
    );
    let cart = getCart();
    let data = [];
    data = yield call(fetchCart, cart, hasBuyMoreGetMore ? code : code[0] || "", dspCode);
    yield put(fetchCartProductsOnSuccess(data, code, checkActionState, dspCode));
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

// Fetch cart
function* fetchCartFlow({ code, dspCode, hasBuyMoreGetMore, checkAction }: AnyAction) {
  try {
    let cart = getCart();
    let data = [];
    data = yield call(fetchCart, cart, hasBuyMoreGetMore ? code : code[0] || "", dspCode);
    yield put(fetchCartProductsOnSuccess(data, code, checkAction, dspCode));
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

function* removePromotionCodeFlow({ code, hasBuyMoreGetMore }: AnyAction) {
  try {
    const dspCodeState = yield select(
      (state: any) => state.products.cart.dspCode,
    );

    let cart = getCart();
    let data = [];

    data = yield call(fetchCart, cart, hasBuyMoreGetMore ? code || [] : "", dspCodeState);
    yield put(
      fetchCartProductsOnSuccess(data, code || [], REMOVE_PROMOTION_CODE_SUCCESS, dspCodeState),
    );
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

function* onChangeIsHaveSetupService({ productId, code }: AnyAction) {
  try {
    let cart = saveIsHaveSetupService(productId);
    const data = yield call(fetchCartUpdate, cart, code);
    yield put(fetchCartProductsOnSuccess(data));
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

function* applyDSPCodeFlow({ dspCode, hasBuyMoreGetMore }: { dspCode: string, hasBuyMoreGetMore: boolean, checkAction: string }) {
  try {
    const couponCodes = yield select(
      (state: any) => state.products.cart.code,
    );
    let cart = getCart();
    let data = [];
    if (cart.length > 0) {
      data = yield call(fetchCart, cart, hasBuyMoreGetMore ? couponCodes : couponCodes[0] || "", dspCode);
    }
    yield put(
      fetchCartProductsOnSuccess(data, couponCodes, APPLY_DSP_CODE_SUCCESS, dspCode),
    );
  } catch (error) {
    yield put(fetchCartProductsOnError(error, APPLY_DSP_CODE_ERROR));
  }
}

function* removeDspCodeFlow({ hasBuyMoreGetMore }: { hasBuyMoreGetMore: boolean }) {
  try {
    const couponCodes = yield select(
      (state: any) => state.products.cart.code,
    );
    let cart = getCart();
    let data = [];
    data = yield call(fetchCart, cart, hasBuyMoreGetMore ? couponCodes : couponCodes[0] || "", "");
    yield put(
      fetchCartProductsOnSuccess(data, couponCodes, REMOVE_DSP_CODE_SUCCESS, ""),
    );
  } catch (error) {
    yield put(fetchCartProductsOnError(error));
  }
}

export default function* watchFetchCartSaga() {
  yield takeLatest(
    DECREASE_INCREASE_CART_PRODUCTS,
    decreaseIncreaseCartProductsFlow,
  );
  yield takeLatest(UPDATE_CART_PRODUCTS, updateCartFlow);
  yield takeLatest(FETCH_CART_PRODUCTS, fetchCartFlow);
  yield takeLatest(
    CHANGE_STATUS_IS_HAVE_SETUP_SERVICE,
    onChangeIsHaveSetupService,
  );
  yield takeLatest(USE_PROMOTION_CODE, applyPromotionCodeFlow);
  yield takeLatest(REMOVE_PROMOTION_CODE, removePromotionCodeFlow);
  yield takeLatest(REMOVE_CART_PRODUCTS, removeCartFlow);
  yield takeLatest(APPLY_DSP_CODE, applyDSPCodeFlow);
  yield takeLatest(REMOVE_DSP_CODE, removeDspCodeFlow);
}
